import { compose, withState, withHandlers, lifecycle, fromRenderProps } from "recompose";
import { connect } from "react-redux";
import { validateProperty, validateObject } from "utils/validator";
import { teamAccountabilitySchema } from "models/teamModel";
import { addDays,getFormatDateY } from "utils/functions"
import { getTeamById, updateTeamAccountability, getAccountabilitySchedule, getUsersByTeam ,getDataRolebyIdUser} from "services/apiAdmin/teamApi";
// questions Api
import { getAccountabilityRecordsListByTeam } from "services/apiAdmin/accountabilityApi";
import {saveMultipleAccountabilityGrades} from "services/apiAdmin/accountabilityApi";
import { setTeamMembersList } from "store/AdminState";

import { verifyPermission } from "utils/functions";

import RecordsListView from "./recordsListView";
import { getUserLocale } from "utils/translate";

const colorsArray = [
	"default",
	"green",
	"red",
	"azure",
	"orange",
	"rose",
]

const newTeam = {
	title: "",
	parentTeamId: "",
	day: "",
	time: "7:00:00"
}

const newTeamState = {
	title: "",
	parentTeamId: "",
	day: "",
	time: ""
}

let _isMounted = false

async function onSubmit(props) {
	let result = await updateTeamAccountability(props.teamId, props.team)
	// Show confirmation message
	if (result && result.success && _isMounted) {
		props.setCreateSuccess(true)
		setTimeout(function () {
			if (_isMounted) {
				props.setCreateSuccess(false)
				//props.history.push('/admin/dashboard')
			}
		}, 1500);
	} else {
		// Show error message
		if (result) {
			let message = result.message
			if (!message) {
				message = "Algo ocurrió mal, inténtalo nuevamente."
			}
			props.setValidationMessage(message)
			props.setCreateError(true)
		}
	}
}

async function getTeam(props, teamId) {
	let result = await getTeamById(teamId)

	if (result.success) {
		if (_isMounted) {
			props.setTeam(result.data)
		}

	}
}

async function getTeamUsers(props, teamId) {
	if (!teamId) {
		return
	}
	let result = await getUsersByTeam(teamId);
	if (_isMounted && result.success) {
		props.setTeamMembersList(result.data)
	}
}

let recordsList;

async function getRecordsByTeam(teamId) {

	let result = await getAccountabilityRecordsListByTeam(teamId);
	if (_isMounted && result.success) {
	
		recordsList = result.data;
		for(let i =0; i < recordsList.length; i++){
			let recordDateString;
			let recordTime_h;
			let recordDate;
			recordDateString=result.data[i].recordDate;
			recordTime_h = result.data[i].recordTime;
			recordDateString= recordDateString.slice(0,10) + " "+ recordTime_h;
			recordDate = new Date(result.data[i].recordDate);
			recordDateString = new Date(recordDateString);
			recordDate = getFormatDateY(recordDate, recordDateString,getUserLocale());
			recordDate = recordDate;
			result.data[i].recordDate = recordDate;
		}
		recordsList = result.data;
		
	}
}

async function getDataRoleIdUser(props){
	
	let result = await getDataRolebyIdUser(props.teamId)
	if(result.success){
		if(result.data.length!=0){
			props.setDataRoleId(result.data[0].dataRoleId)
		}
	}
	
}

async function getSchedule(props, filter) {
	let result = await getAccountabilitySchedule(filter)

	if (result.success) {
		if (_isMounted) {
			const today = new Date();
			const y = today.getFullYear()
			const m = today.getMonth() + 1
			const wd = today.getDay()

			let events = result.data.map((team) => {
				let eventDate = addDays(today, team.day - wd)
				eventDate = new Date(`${y}-${m}-${String(eventDate.getDate()).padStart(2, '0')} ${team.time}`)
				return {
					teamId: team.teamId,
					title: team.title,
					allDay: false,
					start: eventDate,
					end: new Date(eventDate.getTime() + 30 * 60000),
					color: colorsArray[Math.floor(Math.random() * 6)]
				}
			})
			props.setEvents(events)
		}

	}
}


export default compose(
	connect(
		state => ({
			isAuthenticated: state.login.isAuthenticated,
			name: state.login.name,
			teamId: state.admin.teamId,
			roleId: state.admin.roleId,
			team: state.admin.team,
			membersList: state.admin.membersList,
			recordsList: recordsList
		}),
		{ setTeamMembersList }
	),
	withState("team", "setTeam", { ...newTeam }),
	withState("teamState", "setTeamState", { ...newTeamState }),
	withState("events", "setEvents", []),
	withState("viewAllTeams", "setViewAllTeams", true),
	withState("createSuccess", "setCreateSuccess", false),
	withState("createError", "setCreateError", false),
	withState("validationMessage", "setValidationMessage", ""),
	withState("isLoadingSave", "setIsLoadingSave", false),
	withState("dataRoleId","setDataRoleId",""),

	withHandlers({
		newRecord: (props) => (teamId) => {

			// same as here: window.location.href = `/admin/accountabilityrecord/team/${event.teamId}`; to add new. 
			window.location.href = `/admin/accountabilityrecord/team/${teamId}`;
		},
		newMinuteRecord: (props) => (teamId) => {

			// same as here: window.location.href = `/admin/accountabilityrecord/team/${event.teamId}`; to add new. 
			window.location.href = `/admin/accountabilityminute/team/${teamId}`;
		},
		viewRecord: (props) => (teamId) => {
			window.location.href =`/admin/accountabilityrecordlegacy/team/${teamId}`;

		},
 		viewSingleRecord: (props) => (recordId) => {
			// same as here: window.location.href = `/admin/accountabilityrecord/team/${event.teamId}`; to add new. 
			window.location.href = `/admin/accountabilityrecordlegacy/team/${recordId}`;
		},
		newLegacy: (props) => (teamId) =>{
			window.location.href = `/admin/accountabilityrecordlegacy/team/${teamId}`;
		},
		listMinute: (props) => (teamId) =>{
			window.location.href = `/admin/accountabilityminutes/team/${teamId}`;
		},
		minute: (props) => (teamId) =>{
			window.location.href = `/admin/accountabilityrecord/minute`;
		},
		onFieldChange: (props) => (field, value) => {
			props.team[field] = value
			let isValid = validateProperty(teamAccountabilitySchema, props.team, field).isValid
			if (isValid) {
				props.teamState[field] = "success"
			} else {
				props.teamState[field] = "error"
			}
			props.setTeamState(props.teamState)
			props.setTeam(props.team)
		},
		onFilterChange: (props) => async (field, value) => {
			props.setViewAllTeams(value)

			getSchedule(props, value)
		},
		onSave: (props) => async () => {
			props.setIsLoadingSave(true)
			let validation = validateObject(teamAccountabilitySchema, props.team)
			if (validation.isValid) {
				await onSubmit(props)
			} else {
				let field
				for (field in props.team) {
					if (validation.errors[field]) {
						props.teamState[field] = "error"
					}
				}
				props.setTeamState(props.teamState)
			}
			props.setIsLoadingSave(false)

			if (verifyPermission(props.roleId, props.team.dataRoleId, "calendar", "read.all")) {
				getSchedule(props, props.viewAllTeams)
			}
		}
	}),
	lifecycle({
		async componentWillMount() {
			await getRecordsByTeam(this.props.teamId);
		},
		async componentDidMount() {
			_isMounted = true

			await getTeam(this.props, this.props.teamId)
			await getTeamUsers(this.props, this.props.teamId)
			await getDataRoleIdUser(this.props)


			if (verifyPermission(this.props.roleId, this.props.team.dataRoleId, "calendar", "read.all")) {
				getSchedule(this.props, true)
			}

			this.props.setTeamState({ ...newTeamState })
			this.props.setCreateSuccess(false)
			this.props.setViewAllTeams(true)
		},
		async UNSAFE_componentWillUpdate(nextState) {
			// Check team changes
			if (nextState.teamId !== this.props.teamId) {
				await getTeam(this.props, nextState.teamId)
				await getTeamUsers(this.props, this.props.teamId)
			}
		},
		componentWillUnmount() {
			_isMounted = false
		}
	})
)(RecordsListView);
